import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getFertilizer.success: {
            return action.payload;
        }


        case constants.getFertilizer.try:
        case constants.getFertilizer.error: {
            return {};
        }

        default:
            return state;
    }
}